import React from 'react';
import { useField, useFormikContext } from 'formik';

import {
  Select,
  InputLabel,
  FormHelperText,
  FormControl,
  makeStyles, Grid, Paper, Box, Radio, Typography,
} from '@material-ui/core';

// todo move this to own select component
const useStyles = makeStyles(() => ({
  formControl: {
    display: 'flex'
  }
}));

const FormikRadio = ({
  id,
  afterChange,
  options,
  label: selectLabel,
  multiple,
  helperText,
  isRequired,
  ...props
}: any) => {
  // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
  // which we can spread on <input> and also replace ErrorMessage entirely.
  const [field, meta] = useField(props);
  const error = meta.touched && meta.error;
  const formik = useFormikContext();

  const getOption = (typeOption: any) => (
    <Grid
      item
      key={typeOption.value}
    >
      <Paper
        // @ts-ignore
        display="flex"
        // @ts-ignore
        alignItems="center"
        // @ts-ignore
        p={1}
        // @ts-ignore
        pr={3}
        component={Box}
        elevation={field.value === typeOption.value ? 10 : 1}
        key={typeOption.value}
      >
        <Radio
          // @ts-ignore
          name={props.name}
          // @ts-ignore
          id={props.id}
          checked={field.value === typeOption.value}
          // @ts-ignore
          onClick={() => formik.setFieldValue(props.name, typeOption.value)}
        />
        <Box ml={1}>
          <Typography
            gutterBottom
            variant="h5"
            color="textPrimary"
          >
            {typeOption.label}
          </Typography>
        </Box>
      </Paper>
    </Grid>
  );

  return (
    <Box>
      <Box mb={1}>
        <Typography
          variant="caption"
          color="textSecondary"
        >
          {selectLabel}
        </Typography>
      </Box>
      <Grid
        container
        spacing={2}
      >
        {options.map(getOption)}
      </Grid>
      {
          helperText && (
            <FormHelperText>
              {helperText}
            </FormHelperText>
          )
        }
      {
          error && (
            <FormHelperText error>
              {error}
            </FormHelperText>
          )
        }
    </Box>
  );
};

export default FormikRadio;
